import { arrayToEnumObject, ValueTypeOf } from '@berlin-front/common/utils';

export const ROUTE_NAME = arrayToEnumObject([
  'Home',
  'NpAtobaraiLoading',
  'NpAtobaraiFailAuthNg',
  'AtoneLoading',
  'AtoneLiteLoading',
  'AtoneLoadingSettlement',
  'AtoneLiteFailAuthNg',
  'AtoneLiteFailSpappLogin',
  'AtoneLiteFailOfficialIdentification',
  'AtoneLiteLoadingSettlement',
  'AtoneLoadingReauthorize',
  'AtoneIntro',
  'AtoneLoginAtone',
  'AtoneLiteLoginGuest',
  'AtoneLiteLoginAtone',
  'AtoneAuthSmsSettlement',
  'AtoneLiteAuthSmsNew',
  'AtoneLiteAuthSmsAtone',
  'AtoneLiteAuthSmsGuest',
  'AtoneSettlementConfirm',
  'AtoneAuthCall',
  'AtoneFailSpappLogin',
  'AtoneFailOfficialIdentification',
  'AtoneFailAuthNg',
  'AtoneFailCart',
  'AtoneLiteLoading',
  'AtoneLiteAuthSmsSettlement',
  'ErrorView',
  'AtoneMemberNpLogin',
  'AtoneMemberRegister',
  'AtoneMemberConfirm',
  'AtoneMemberAuth',
  'AtoneLiteMemberNpLogin',
  'AtoneLiteMemberRegister',
  'AtoneLiteMemberConfirm',
  'AtoneLiteMemberAuth',

  'AtoneNpMemberLogin',
  'AtoneNpMemberRegister',
  'AtoneNpMemberConfirm',
  'AtoneNpMemberAuth',

  // service-type: 05
  'AtoneAuthErrorView',
  'AtoneauthInitLoading',
  'AtoneauthIntro',
  'AtoneauthByAtoneMember',
  'AtoneauthAtoneMemberSmsAuth',
  'AtoneauthByNpMember',
  'AtoneauthNpMemberRegister',
  'AtoneauthNpMemberConfirm',
  'AtoneauthNpMemberSmsAuth',
  'AtoneauthComplete',
  'AtoneauthAuthSmsSettlement',
  'AtoneauthGuestMemberRegister',
  'AtoneauthMemberRegister',
  'AtoneauthMemberConfirm',
  'AtoneauthGuestMemberConfirm',
  'AtoneauthMemberSmsAuth',
  'AtoneauthGuestSmsAuth',

  // service-type: 06
  'AtoneLiteAuthErrorView',
  'AtoneLiteAuthInitLoading',
  'AtoneLiteAuthAtoneMemberLogin',
  'AtoneLiteAuthAtoneMemberSmsAuth',
  'AtoneLiteAuthComplete',
  'AtoneLiteAuthNpMember',
  'AtoneLiteAuthNpMemberRegister',
  'AtoneLiteAuthNpMemberConfirm',
  'AtoneLiteAuthNpMemberSmsAuth',
  'AtoneLiteAuthGuestLogin',
  'AtoneLiteAuthNewGuestSmsAuth',
  'AtoneLiteAuthExistGuestSmsAuth',

  // atone-split-service
  'AtoneSplitSelect',
  'AtoneSplitSettlementSplit',
  'AtoneSplitSettlementOneTime',
  'AtoneSplitLoadingSettlement',
]);

export type RouteName = ValueTypeOf<typeof ROUTE_NAME>;
